export default __webpack_public_path__ + "static/media/remeberOff.b7daa2ba.svg";